import React from "react";

// Style \\
import "../../assets/styles/card/deliverCard.scss";

// Image \\
import guarantee_1 from "../../assets/images/shutterstock_46407883.jpg";
import guarantee_2 from "../../assets/images/100-guarantee.jpg";

const Repair = () => {
  return (
    <div>
      <div className="cardFreeCheck2">
        <div className="image">
          <img src={guarantee_1} alt="" /> <img src={guarantee_2} alt="" />{" "}
        </div>
        <div className="desc">
          <div className="moto">
            <h4>
              We guarantee our products <br /> for a year
            </h4>
          </div>

          <div className="plusSides">
            <div className="boxService">
              <div className="each">
                <div className="dot"></div>
                <p>Lorem ipsum dolor sit.</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>Lorem ipsum.</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>Lorem ipsum dolor sit.</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>Lorem ipsum dolor.</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>Lorem ipsum dolor.</p>
              </div>
              <div className="each">
                <div className="dot"></div>
                <p>Lorem ipsum.</p>
              </div>
            </div>
          </div>

          <div className="com">
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              placerat scelerisque tortor ornare ornare. Quisque placerat
              scelerisque tortor ornare ornare Convallis felis vitae tortor
              augue. Velit nascetur proin massa in. Consequat faucibus porttitor
              enim et.
            </p>
            <p className="two">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Quisque
              placerat scelerisque. Convallis felis vitae tortor augue. Velit
              nascetur proin massa in.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Repair;
